import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Checkbox } from '../../../../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { IconButton } from '../../../../../../../../CommonComponents/OPL/IconButton/IconButton';

interface SortablePlanSelectorItemProps {
  planId: string;
  name: string;
  checked: boolean;
  disabled: boolean;
  onToggle(): void;
}

export const SortablePlanSelectorItem = ({
  planId,
  name,
  checked,
  disabled,
  onToggle,
}: SortablePlanSelectorItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: planId,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gridGap={4}
      mx="4"
      my="4"
    >
      <Box flex={1} minWidth={0}>
        <Checkbox checked={checked} onChange={onToggle} disabled={disabled} isOverflowWrap>
          {name}
        </Checkbox>
      </Box>

      <IconButton
        icon="fas fa-grip-vertical"
        variant="subtleInactive"
        style={{ cursor: 'grab', flexShrink: 0 }}
        aria-label={`Drag to reorder ${name}`}
        {...attributes}
        {...listeners}
      />
    </Box>
  );
};
